import React, { useEffect, useState } from "react";
import "react-tooltip/dist/react-tooltip.css";
import {
  useCompleteFormAction,
  useDisEngageForm,
  useSubmitOfficialInfo,
  useUpdateForm,
  usemo,
  useMoveFormActionToRole,
  useMoveFormActionToRoleAndBranch
} from "../../hooks/forms/useUpdate";
import TextField from "../../components/TextField";
import { useGetFormSection, useGetNonEngagedForm } from "../../hooks/forms/useGet";
import { TbDotsVertical } from "react-icons/tb";
import { AiOutlineCheck } from "react-icons/ai";
import { HiOutlineXMark } from "react-icons/hi2";
import { HiMenuAlt3 } from "react-icons/hi";
import SectionFormFields from "../../components/sectionFormFields";
import MiniPopUp from "../../components/miniPopUp";
import FormMetadata from "../../components/FormMetadata";
import { useRejectForm } from "../../hooks/forms/useDelete";
import Modal from "../../components/Modal";
import { useCreateComment } from "../../hooks/forms/useCreate";
import Loader from "../../components/Loader";
import { Link } from "react-router-dom";
import { GiFeather } from "react-icons/gi";
import { AiOutlineSend } from "react-icons/ai";
import { Tooltip } from "react-tooltip";
import AddComment from "../create/AddComment";
import { useGetBranches } from "../../hooks/branches/useGet";
import { useGetRoles } from "../../hooks/roles/useGet";
import Select from "../../components/Select";
import { mapFormValuesToSections } from "../../utils/Mappings";

// ⬇️ NEW: bring in role list + user helper and the nice card
import { BRANCH_ROLES } from "../../utils/constant";
import { safeGetUser } from "../../utils/helpers";
import { NotAuthorizedCard } from "../../components/NotAuthorizedComponent";

const ViewHistoryForm = ({ id }) => {
  const { officerId, roleId } = JSON.parse(localStorage.getItem("user"));
  const [commentModal, setCommentModal] = useState(false);

  // ROLES
  const { data: roles, isSuccess: gotRoles } = useGetRoles();
  const roleSelectOptions = roles?.map((item) => ({
    name: item.roleName,
    value: item.roleId
  }));

  // BRANCHES
  const { data: branches, isSuccess: gotBranches } = useGetBranches(1, 100);
  const branchSelectOptions = branches?.map((item) => ({
    name: `${item.branchCode} (${item.branchName})`,
    value: item.branchId
  }));

  // FORM + SECTION
  const {
    data: form,
    isSuccess: gotForm,
    isError: isFormError,
    error: formError,
    isLoading
  } = useGetNonEngagedForm(id, officerId);
  const { data: section, isSuccess: gotFormSection } = useGetFormSection(id);

  // MUTATIONS
  const { mutate: createComment, data: commentData, isSuccess: sentComment } = useCreateComment();
  const { mutate: disengage, error: createError, isLoading: disengageLoading, isSuccess: disengageSuccess } =
    useDisEngageForm(id, officerId);
  const {
    mutate: rejectAction,
    data: rejectedData,
    error: rejectionError,
    isLoading: rejectActionLoading,
    isSuccess: rejectActionSuccess
  } = useRejectForm(id);
  const {
    mutate: completeAction,
    data: completeData,
    error: completeActionError,
    isLoading: completeActionLoading,
    isSuccess: completeActionSuccess
  } = useCompleteFormAction(id);
  const {
    mutate: moveFormToRole,
    data: moveToRoleData,
    error: moveToRoleError,
    isLoading: moveToRoleLoading,
    isSuccess: moveToRoleSuccess
  } = useMoveFormActionToRole(id);
  const {
    mutate: moveFormToRoleAndBranch,
    data: moveToRoleAndBranchData,
    error: moveToRoleAndBranchError,
    isLoading: moveToRoleAndBranchLoading,
    isSuccess: moveToRoleAndBranchSuccess
  } = useMoveFormActionToRoleAndBranch(id);

  const formValues = form?.formValues?.map((item) => ({ value: item?.formData, label: item?.formField?.label }));
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [result, setResult] = useState(null);
  const { formFields } = section || [];
  const { mutate: updateForm, error: updateError, isLoading: editLoading, isSuccess } = useUpdateForm(id);
  const { mutate: submitInfo, error: infoSubmitError, isLoading: infoSubmitLoading, isSuccess: infoSubmitSuccess } =
    useSubmitOfficialInfo(id);

  const [data, setData] = useState({});
  const [showPopUp, setShowPopUp] = useState(false);
  const [togglePreviewModal, setTogglePreviewModal] = useState(false);
  const [openPanel, setOpenPanel] = useState(false);
  const [actionMessage, setActionMessage] = useState("");
  const [actionTitle, setActionTitle] = useState("");

  // ⬇️ NEW: privilege/branch gate
  const user = safeGetUser();
  const isPrivileged = !BRANCH_ROLES.includes(user?.roleName);
  const blocked =
    gotForm && // only after form is fetched
    !isPrivileged &&
    user?.branchId &&
    form?.branchId &&
    Number(user.branchId) !== Number(form.branchId);

  const togglePanel = () => {
    setOpenPanel((prevState) => !prevState);
  };

  const [state, setState] = useState({
    roleId: "",
    branchId: "",
    comment: ""
  });

  const handleChange = ({ target: { name, value } }) => {
    setState({ ...state, [name]: value });
  };

  const updateData = (e) => {
    setData({
      ...data,
      [e.target.name.replace(/\s/g, "")]: { formData: e.target.value, formId: id, formFieldId: e.target.id }
    });
  };

  window.onpopstate = () => {
    disengage({ formId: form?.formId, officerId });
  };

  const handleSubmitComment = (e) => {
    e.preventDefault();
    createComment({ message: state.comment, formId: id, officerId });
  };

  const onSubmit = (e) => {
    e.preventDefault();
    const _data = [];
    for (const _obj in data) _data.push(data[_obj]);
    submitInfo(_data);
  };

  const AcceptForm = () => {
    completeAction({ formId: id, officerId });
  };

  const sendFormToRole = () => {
    moveFormToRole({ formId: id, roleId: state.roleId });
  };
  const sendFormToBranch = () => {
    moveFormToRoleAndBranch({ formId: id, roleId: state.roleId, branchId: state.branchId });
  };
  const sendForm = () => {
    if (state.roleId == "") {
      setTogglePreviewModal(true);
      setActionTitle("Error Found");
      setActionMessage("You cannot send a form without assigning roles to the receiver");
      return;
    }
    if (state.branchId == "") {
      sendFormToRole();
      return;
    } else {
      sendFormToBranch();
    }
  };

  useEffect(() => {
    if (moveToRoleSuccess || moveToRoleAndBranchSuccess) {
      setTogglePreviewModal(true);
      setActionTitle("Form Sent ");
      setActionMessage("You have succesfully moved the form to a new role / branch");
      setTimeout(() => {
        window.location.reload();
      }, 2000);
    }
  }, [moveToRoleSuccess, moveToRoleAndBranchSuccess]);

  useEffect(() => {
    if (moveToRoleError || moveToRoleAndBranchError) {
      setTogglePreviewModal(true);
      setActionTitle("Error  ");
      setActionMessage("Form not sent , contact the admin for assistance");
    }
  }, [moveToRoleError, moveToRoleAndBranchError]);

  const RejectForm = () => {
    rejectAction({ formId: id, officerId });
  };

  useEffect(() => {
    if (infoSubmitSuccess) {
      window.location.reload();
    }
  }, [infoSubmitSuccess]);

  useEffect(() => {
    if (isSuccess) {
      setSuccess("Form updated successfully");
      setTimeout(() => {
        window.location.reload();
      }, 2000);
    }
  }, [isSuccess]);

  useEffect(() => {
    const mapppedData = mapFormValuesToSections(form);
    setResult(mapppedData);
  }, [form]);

  useEffect(() => {
    if (rejectActionSuccess) {
      setActionTitle("Form Rejection");
      setActionMessage(rejectedData?.data?.message || "");
      setTogglePreviewModal(true);
    }
  }, [rejectActionSuccess]);

  useEffect(() => {
    if (updateError) {
      const message = updateError?.response?.data?.message;
      setError(message);
    }
  }, [updateError]);

  const handlePreviewModalToggle = () => {
    setTogglePreviewModal((prevState) => !prevState);
  };

  const handleHidePop = (event) => {
    const container = document.getElementById("formMetadata");
    const miniPopUp = document.getElementById("MiniPopUp");
    if (container != null && !container.contains(event.target)) {
      togglePanel();
    }
    if (miniPopUp != null && !miniPopUp.contains(event.target)) {
      setShowPopUp(false);
    }
  };

  const toggleCommentModal = () => setCommentModal((p) => !p);

  // ⬇️ Show restriction card (same placement pattern you used in ViewForm)
  if (blocked) {
    return (
      <div className="w-full relative min-h-screen">
        <NotAuthorizedCard onBack={() => window.history.back()} />
      </div>
    );
  }

  if (isLoading || moveToRoleAndBranchLoading || moveToRoleLoading) return <Loader className={"fixed inset-0"} />;

  if (isFormError && formError) {
    return (
      <div className={"min-h-[70vh] flex flex-col items-center justify-center"}>
        <span className={"text-4xl"}>{formError?.response?.data?.message}</span>
        <Link to={"/"} className={"text-white block my-3 rounded p-2 bg-[#0A0D36] w-full hover:decoration-0"}>
          Back
        </Link>
      </div>
    );
  }

  return (
    <div className=" w-[100%] fixed inset-0 relative min-h-[60vh]" onClick={handleHidePop}>
      <div className="px-[30px]  flex justify-center relative  ">
        <div className="max-w-7xl mx-auto ">
        <div className="branch_header">
  <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6 mb-6 md:mb-8">
    {/* Title / ticket */}
    <div className="branch_header_title_main w-full md:w-[50vw]">
      <div className="uppercase font-bold text-base sm:text-lg">
        {form?.formType?.formTypeName ?? "Details"}
      </div>
      <div className="text-[13px] sm:text-[15px] text-gray-700">
        {form?.ticketNumber ?? ""}
      </div>
    </div>

    {/* Actions (Info button to open the panel) */}
    <div className="border-0 flex flex-col md:flex-row md:items-center md:justify-end gap-3 md:gap-4">
      <div
        className="border-0 w-full md:w-[600px] flex flex-col md:flex-row gap-3 md:gap-4 items-stretch md:items-center justify-between py-3 md:py-5 print:hidden"
        hidden={form?.isCompleted}
      >
        {/* Keep empty in history view (read-only) */}
      </div>

      <div className="flex flex-wrap items-center justify-end gap-2 md:gap-3 py-3 md:py-5 print:hidden">
        <button
          onClick={() => setOpenPanel(!openPanel)}
          className="rounded px-2 h-10 flex justify-center items-center text-[15px]"
          aria-label="Info"
        >
          <HiMenuAlt3 size={22} />
        </button>
      </div>
    </div>
  </div>
</div>


          {/* form */}
          {gotForm && (
            <form className="space-y-8 relative">
              {result?.map((section) => (
                <div key={section.formSectionId} className="pb-6 border-b">
                  <h3 className="text-sm font-semibold text-gray-700 mb-3 bg-gray-100 p-3 rounded mb-10">
                    {section.name}
                  </h3>

                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    {section.formFields?.map((field) => (
                      <div key={field.formFieldId} className="flex items-start">
                        <TextField
                          disabled
                          label={field.label}
                          name={`field_${field.formFieldId}`}
                          type="text"
                          value={field.value ?? ""}
                        />
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </form>
          )}

          <Modal
            toggleModal={togglePreviewModal}
            title={actionTitle}
            form={<span>{actionMessage}</span>}
            handleToggle={handlePreviewModalToggle}
          />

         {openPanel && (
  <FormMetadata
    formHistoryActions={form?.formActionHistories ?? []}
    formTransitHistories={form?.formTransitHistories ?? []}
    comments={form?.comments ?? []}
    togglePanel={togglePanel}
  />
)}

          {section && (
            <SectionFormFields
              form={form}
              formFields={formFields}
              section={section}
              showSection={gotFormSection}
              onSubmit={onSubmit}
              updateData={updateData}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default ViewHistoryForm;
